import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { withTheme, withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import { compose } from 'redux';
import { Route, withRouter } from 'react-router-dom';
import NavbarNew from '../../components/NavBarNew/NavbarNew';
import AreYouSureAlert from '../../components/Alert/AreYouSureAlert';
import { getCookies } from '../../utils/getToken';
import Axios from 'axios';
import { SERVER_URL } from '../../utils/config/constants';
import { NotificationManager } from 'react-notifications';
import { roundUpTransaction } from '../../utils/roundUpTransaction';

const sendProps = props => {
    const { classes, ...rest } = props;
    return rest;
};
const styles = theme => ({
    heading: {
        color: '#ffffff'
    },
    paper: {
        backgroundColor: theme.palette.primary.main
    },
    card: {
        color: theme.palette.secondary.main
    }
});
let isLoading = true;
class ProposeNewPriceScreenNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            revice_price_alert: false,
            loader: true,
            bookingDetails: this.props.history.location.state.bookingDetails,
            prev_route: this.props.history.location.state.prev_route,
            propose_price: '',
            propose_reason: '',
            original_price: this.props.history.location.state.bookingDetails.provider_booking_value
        };
    }
    componentDidMount() {
        console.log('this.state.original_price', this.state.original_price);
    }

    continueRevisePrice = async () => {
        var authToken = getCookies();
        console.log('booking id', this.state.prev_route === 'todays_route' ? this.state.bookingDetails.booking_id : this.state.bookingDetails.booking_id);
        this.setState({
            showAlert: false
        })
        try {
            const { data } = await Axios({
                method: 'post',
                url: `${SERVER_URL}/booking/provider-revise-price`,
                data: {
                    provider_booking_id: this.state.bookingDetails.id,
                    booking_id: this.state.bookingDetails.booking_id,

                    // booking_id: this.state.prev_route === 'todays_route' ? this.state.bookingDetails.booking_id : this.state.bookingDetails.booking_id ,
                    revise_price: this.state.propose_price,
                    revise_price_reason: this.state.propose_reason,
                },
                headers: {
                    'x-auth-Token': authToken,
                },
            });
            console.log('revise price data', data);
            if (data.status == 'OK') {
                this.setState({
                    loading: false,
                    showAlert: false
                })
                NotificationManager.success(data.message, 'Success');
                this.props.history.push('/provider/manage_bookings')
            }
            else {
                this.setState({
                    loading: false,
                    showAlert: false
                })
                NotificationManager.error(data.message, 'Error');
                this.props.history.push('/provider/manage_bookings')
            }
        } catch (error) {
            console.log("=========================== revise price ERRORRRRRR", error);
        }
    }

    render() {
        var card = {
            border: '1px solid #eee',
            boxShadow: '1px 1px 20px #ddd',
            borderRadius: '10px',
            marginBottom: 20,
            padding: 20,
            // width: '50%',
            height: '100%',
            margin: 30
        }
        return (
            <div className="tz-2-com tz-2-main">
                <NavbarNew
                    title='Propose New Price'
                    goback={() => this.props.history.goBack(null)}
                />
                <div style={card}>
                    <p style={{
                        fontSize: 17,
                        fontWeight: 'bold',
                    }}>Original Price</p>
                    <p style={{
                        border: '1px solid #eee',
                        padding: 10,
                        borderRadius: 5
                    }}>${roundUpTransaction(this.state.original_price)}</p>
                    <p style={{
                        marginTop: 20,
                        fontSize: 17,
                        fontWeight: 'bold',
                    }}>New Price</p>
                    <input
                        style={{
                            border: '1px solid #eee',
                            padding: 10,
                            borderRadius: 5
                        }}
                        placeholder='Enter New Price'
                        value={this.state.propose_price}
                        onChange={(e) => this.setState({
                            propose_price: e.target.value
                        })}
                    />
                    {
                        this.state.propose_price
                            ?
                            <p> Will be shown to customer as ${roundUpTransaction(Number(this.state.propose_price) * 1.25)}</p>
                            : null
                    }
                    <p style={{
                        marginTop: 30,
                        fontSize: 17,
                        fontWeight: 'bold',
                    }}>Reason for price change</p>
                    <textarea
                        // id="required"
                        // className="border-0 form-control chat-textarea"
                        // onKeyUp={this._handleKeyPress.bind(this)}
                        onChange={(e) => this.setState({
                            propose_reason: e.target.value
                        })}
                        value={this.state.propose_reason}
                        placeholder="Enter reason for price change"
                        style={{
                            height: '20vh',
                            borderRadius: '5px',
                            padding: 10
                        }}
                    />
                </div>
                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    padding: '0 20px'
                }}>
                    <p

                        onClick={() =>
                            !this.state.propose_price
                                ? NotificationManager.warning('Please enter propose price', '')
                                : !this.state.propose_reason
                                    ? NotificationManager.warning('Please enter reason', '')
                                    : Number(this.state.original_price) > Number(this.state.propose_price)
                                        ? NotificationManager.warning('New price should be greater than original price', '')
                                        :
                                        this.setState({
                                            revice_price_alert: true
                                        })}
                                     
                        style={{
                            backgroundColor: '#0078ff',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                            width: '28%',
                            margin: 10,
                            padding: 10,
                            color: 'white',
                            fontSize: 18,
                            fontWeight: '700',
                            borderRadius: 5
                        }}>Continue</p>

                </div>
                <AreYouSureAlert
                    open={this.state.revice_price_alert}
                    title=""
                    content='Keep in mind all price increases need to be done prior to starting work. If your price request is rejected the job will be canceled and no payment will be made to you and customer will be refunded their money. Do you want to continue?'
                    close={() => this.setState({ revice_price_alert: false })}
                    handleYes={this.continueRevisePrice}
                    handleNo={() => this.setState({ revice_price_alert: false })}
                />
            </div>
        );
    }
}

// const mapStateToProps = ({ settings }) => {
//     return {
//         colors: settings.colors
//     };
// };
const composedComponent = compose(
    withStyles(styles),
    withTheme(),
    connect(
        null,
        actions
    )
);

export default withRouter(composedComponent(ProposeNewPriceScreenNew));



// WEBPACK FOOTER //
// ./src/views/ProviderScreensNew/ProposeNewPriceScreenNew.jsx